























































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../lib/util'
import AbpBase from '../../lib/abpbase'
import Equipmentmodel from '../../store/entities/equipmentmodel'
import appconst from '../../lib/appconst'


 

@Component
export default class EditEquipmentmodel extends AbpBase{


    
    @Prop({type:Boolean,default:false}) value:boolean;

    user:Equipmentmodel=new Equipmentmodel();
    

 

  
  

   
   


    save(){
        //(this. $refs.userForm as any).vid= this.nowvid;
       

           

        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            
            
            if(valid){
                await this.$store.dispatch({
                    type:'equipmentmodel/update',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
           
          
        if(!value){
            this.$emit('input',value);
          
       
        }else{
     
            this.user=Util.extend(true,{},this.$store.state.equipmentmodel.editEquipmentmodel);

               
           //
        //下面小区
        //  var vcid=this.$store.state.goods.editGoods.vid;
        
            // var cid=this.area_ByVarea(vcid);
            
        }
    }
    created() {

    }
    chang_containercoding(){
   
    this.user.containercoding=this.user.containercapacity.toLocaleString()+this.user.containermaterial.toLocaleString()+this. user.containertype.toLocaleString();                
    this.user.temperaturewarningvalue=50;//	 	温度预警值(℃)       
    this.user.displacementwarningvalue	=1000;		//	位移预警值(m)
    this.user.nowasteintervalwarningvalue=6;//		无废间隔预警值(月)
    this.user.dataheartbeatinterval	 =25;	 //	数据心跳间隔(h)

   
   }
    userRule={
      
        
          modelname:[{required: true,message:'请输入型号名称',trigger: 'blur'}],
         wastetype:[{type:'number',  required: true,message:'请选择产废类型',}],
         containercoding:[{required: true,message:'请输入或选择容量代码、位材质代码、位容器类型代码(代码规则：1位容量代码+1位材质代码+1位容器类型代码)'}],
         storagepointtype:[{type:'number',  required: true,message:'请选择贮存点类型',}],
         sizeunits:[{type:'number',  required: true,message:'请选择贮存点大小单位',}],
         storagesize:[{ required: true,message:'请输入贮存点大小'}],
         capacityunit:[{type:'number',  required: true,message:'请选择贮存能力单位',}],
         storagecapacity:[{required: true,message:'请输贮存能力'}],

          
         electricitywarningvalue:[{ required: true,message:'请输入电量预警值（°）'}],
         temperaturewarningvalue:[{required: true,message:'请输入温度预警值(℃)'}],
        
         weightwarningvalue:[{ required: true,message:'请输入重量预警值(kg)' }],
         reductionwarningvalue:[{ required: true,message:'请输入减量预警值(kg)' }],
         displacementwarningvalue:[{ required: true,message:'请输入位移预警值(m)'}],
         nowasteintervalwarningvalue:[{ required: true,message:'请输入无废间隔预警值(月)'}],
         dataheartbeatinterval:[{required: true,message:'请输入数据心跳间隔(h)'}],
         containertype:[{type:'number',  required: true,message:'请选择容器类型',trigger: 'blur,change'}],
         containercapacity:[{type:'number',  required: true,message:'请选择容器容量',trigger: 'blur,change'}],
         containermaterial:[{type:'number',  required: true,message:'请选择容器材质',trigger: 'blur,change'}],
  
    }
    


    
}  





